import { MaterialModule } from '../../core/modules/materials.module'
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LocationSelectorComponent } from './location-selector.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
  ],
  declarations: [
    LocationSelectorComponent
  ],
  exports: [
    LocationSelectorComponent
  ]
})
export class LocationSelectorModule { }
